// extracted by mini-css-extract-plugin
var _1 = "LzXcgK0s23NWlxxIXYKc";
var _2 = "alaqn107UWPjd8xo7mWG";
var _3 = "dark-mode";
var _4 = "ZMcEtjf0Nrdkc0iDHP1p";
var _5 = "yimtk85EKBmGtAkMVXQ5";
export { _1 as "active", _2 as "container", _3 as "dark-mode", _4 as "toggle", _5 as "wrapper" }
